
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import PageTopTitle from "../shared/PageTopTitle"
import { showModal, showNestedModal } from "../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import Button from "../shared/Button"
import { handleActiveSelect } from "../../features/layout/layoutSlice"
import GarajDetayListItem from "../garaj/GarajDetayListItem"
import { HiOutlineMenuAlt4, HiOutlineMinus }from "react-icons/hi"
import {BiColor } from "react-icons/bi"
import GarajDetayListItemAnimated from "../garaj/GarajDetayListItemAnimated"
import AreaChart from "../charts/recharts/AreaChart"
import BarChart from "../charts/recharts/BarChart"
import {AiOutlineBarChart, AiOutlineAreaChart} from "react-icons/ai"
import { getGarajItemData } from "../../features/admin/adminSlice"
import Btn from "../shared/button/Btn"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1500px;
        min-height: 600px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 100%;
            height: 600px;
            padding: 30px;
            display: flex;
            justify-content: space-between;

            .stats-container{
                width: calc(52% - 20px);
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                .list{
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    gap: 15px;
                    height: 550px;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 0;
                        width: 5px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background-color: #9e9b9b;
                        border-radius: 10px;
                    }
                    &::-webkit-scrollbar-track {
                        background-color: transparent;
                    }

                }
            }

            .chart-container{
                display: flex;
                flex-direction: column;
                width: calc(48% - 20px);

                .chart-wrapper{
                    width: 100%;
                    height: 420px;
                }

            }


            .icons-container{
                width: 100%;
                display: flex;
                justify-content: center;
                margin-top: 20px;
                gap: 20px;

                .icon-wrapper{
                    border-radius: 10px;
                    padding: 10px;
                    border: 1px solid ${({ theme }) => theme.mainTextColor};
                    cursor: pointer;

                    .chart-icon{
                        font-size: 2rem;
                        color: 2px solid ${({ theme }) => theme.mainTextColor};
                    }

                }

                .active-chart{
                    background-color: var(--color-main);
                    border-color: transparent;

                    .chart-icon{
                        color: #000;
                    }
                }
            }
        }

        .btn-container{
            width: 100%;
            height: 80px;
            border-top: 1px solid ${({ theme }) => theme.mainBorderColor};
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 40px;
        }


    }
`

const TitleContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 5px;
    border-bottom: 2px solid ${({ theme }) => theme.mainTextColor};

    .title{
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-lg);
    }

    .controller{
        display: flex;
        align-items: flex-end;
        cursor: pointer;

        .icon{
            font-size: 1.4rem;
            fill: ${({ theme }) => theme.mainTextColor};
        }

        //! bunu ileride kaldır
        .transparent{
            fill: transparent;
        }
    }
`

const GarajDetayModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()
    const [formattedList ,setFormattedList] = useState([])
    const [reversedFormattedList, setReversedFormattedList] = useState([])

    const [chartType ,setChartType] = useState("area")

    const [isAnimated, setIsAnimated] = useState(false)

    const {modalLocation } = useSelector(state => state.modal)
    const {garajDetayData} = useSelector(state => state.admin)
    const { lockScroll, unlockScroll } = useScrollLock();


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])



    //! BsCalendar2Check
    //! TbCalendarCheck

    useEffect(() => {
        if(garajDetayData.length > 0){
          setFormattedList(garajDetayData.map((item) => {
            const date = new Date(item.entryTime)
            return {...item, entryTime:date.toLocaleDateString(), time: date.toLocaleTimeString()}
          }))

          setReversedFormattedList(garajDetayData.map((item) => {
            const date = new Date(item.entryTime)
            return {...item, entryTime:date.toLocaleDateString(), time: date.toLocaleTimeString()}
          }).toReversed())
        }
      },[garajDetayData])
  

    const dataKeys = [
        { key: "loadDensity", color: "#8884d8", fill: "url(#colorUv)" },
        { key: "vehicleDensity", color: "#82ca9d", fill: "url(#colorPv)" }
    ]
    const mainDataKey = "entryTime"


        if(formattedList.length < 1){
            return null
        }
    
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Garaj Detay"}/>
            <div className="content">
                <div className="stats-container">
                    <TitleContainer>
                        <h3 className="title">{formattedList[0]?.branchName} Kamyon Garajı (Kayıtlı Son {formattedList.length} Veri)</h3>
                        <div className="controller">
                            {
                                isAnimated ? <HiOutlineMenuAlt4 className="icon" onClick={() => setIsAnimated(!isAnimated)}/>:
                                <BiColor className="icon" onClick={() => setIsAnimated(!isAnimated)}/>
                            }
                        </div>
                    </TitleContainer>

                    <div className="list">
                        {
                            formattedList.map((item, i) => {
                                if(isAnimated){
                                    return <GarajDetayListItemAnimated item={item} key={i}/>
                                }
                                else{
                                    return <GarajDetayListItem item={item} key={i}/>
                                }
                            })
                        }
                    </div>
                </div>

                <div className="chart-container">
                    <TitleContainer>
                        <h3 className="title">{formattedList[0]?.branchName} Kamyon Garajı Grafiği (Kayıtlı Son {formattedList.length} Veri)</h3>
                        <div className="controller">
                            {
                                isAnimated ? <HiOutlineMenuAlt4 className="icon" onClick={()=> {}}/>:
                                <BiColor className="icon transparent" onClick={()=> {}}/>
                            }
                        </div>
                    </TitleContainer>
                    <div className="chart-wrapper">
                        {
                            (chartType === "area" && reversedFormattedList) &&
                            <AreaChart data={reversedFormattedList} dataKeys={dataKeys} mainDataKey={mainDataKey}/>
                        }
                        {
                            (chartType === "bar" && reversedFormattedList) &&
                            <BarChart data={reversedFormattedList} dataKeys={dataKeys} mainDataKey={mainDataKey}/>
                        }
                    </div>
                    <div className="icons-container" >
                        <div className={chartType === "area" ? "icon-wrapper active-chart": "icon-wrapper"} onClick={() => setChartType("area")}>
                            <AiOutlineAreaChart className={chartType === "area" ? "chart-icon active-chart": "chart-icon"} />
                        </div>
                        <div className={chartType === "bar" ? "icon-wrapper active-chart": "icon-wrapper"} onClick={() => setChartType("bar")}>
                            <AiOutlineBarChart className={chartType === "bar" ? "chart-icon active-chart": "chart-icon"} />
                        </div>
                    </div>
                </div>

            </div>
            <div className="btn-container">
                <Btn color={"#E85446"} bgColor={"transparent"} width="260px" radius={"10px"} handleClick={()=> dispatch(showModal(null))} >Geri Dön</Btn>
                <Btn color={"#E85446"} bgColor={"transparent"} width="260px" radius={"10px"} handleClick={()=> {dispatch(getGarajItemData(formattedList)); dispatch(showNestedModal("addGarajYogunlukEntry"))}}>Yeni Bir Girdi Ekle</Btn>
                {/* <Button color={"#F4F4F4"} background={"#0EAC00"} width="260px" radius={"10px"} text={""} handleClick={()=> dispatch(showModal(null))}/>
                <Button color={"#F4F4F4"} background={"#0EAC00"} width="260px" radius={"10px"} text={""} handleClick={()=> {dispatch(getGarajItemData(formattedList)); dispatch(showNestedModal("addGarajYogunlukEntry"))}}/> */}
            </div>
        </div>
    </ModalContainer>
  )
}

export default GarajDetayModal
